export const banPlayerInPlayFab = async (playfabId,DurationInHours) => {
  const url = "https://icgbunklihjbwsjrfmpy.supabase.co/functions/v1/ban-player";

  const headers = {
    "Content-Type": "application/json",
    "Authorization": `${process.env.REACT_APP_SUPABASE_ANON_KEY}`, // ✅ Add Supabase API key
  };


  console.log("🔑 Supabase API Key:", process.env.REACT_APP_SUPABASE_ANON_KEY);
  const body = { playfabId,DurationInHours};
  console.log("🧐 body :", body);
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Error banning player:", data.error);
      throw new Error(data.error);
    }

    console.log("✅ Player Banned Successfully:", data);
    return data;
  } catch (error) {
    console.error("❌ Network or API error:", error);
    throw error;
  }
};
